'use strict';

var classicTv = 'magcore-app-tv-classic',
    tv = 'magcore-app-tv';


module.exports = function ( config ) {
    var gettext = require('mag-gettext').gettext;

    if ( window.core.backend && window.core.backend.settings ) {
        return {
            id: 'homeApplication',
            icon: 'theme-icon-monitor',
            name: gettext('Home page'),
            description: gettext('Selecting a menu section that will be loaded when you turn on the set-top box'),
            render: config.api.renders.popupSelect,
            variable: {
                name: 'homeApp',
                value: null
            },
            requirePortalReboot: true,
            prepareForRender: function ( value, callback ) {
                var showMainMenuOnStart = !value,
                    preparedData;

                console.log('prepare for render main page, value: ' + value);
                if ( window.core.packageMap[classicTv] && window.core.packageMap[tv] ) {
                    preparedData = [
                        {name: gettext('Last TV channel'), value: tv, selected: !showMainMenuOnStart && value === tv},
                        {name: gettext('Last TV Classic channel'), value: classicTv, selected: !showMainMenuOnStart && value === classicTv},
                        {name: gettext('Startup menu'), value: null, selected: showMainMenuOnStart}
                    ];
                } else if ( window.core.packageMap[tv] )  {
                    preparedData = [
                        {name: gettext('Last TV channel'), value: tv, selected: !showMainMenuOnStart && value === tv},
                        {name: gettext('Startup menu'), value: null, selected: showMainMenuOnStart}
                    ];
                } else if ( window.core.packageMap[classicTv] )  {
                    preparedData = [
                        {name: gettext('Last TV channel'), value: classicTv, selected: !showMainMenuOnStart && value === classicTv},
                        {name: gettext('Startup menu'), value: null, selected: showMainMenuOnStart}
                    ];
                } else {
                    preparedData = [
                        {name: gettext('Last TV channel'), value: tv, selected: !showMainMenuOnStart},
                        {name: gettext('Startup menu'), value: null, selected: showMainMenuOnStart}
                    ];
                }
                // var


                callback(preparedData);
            },
            prepareForSave: function ( value, callback ) {
                // if ( value === 'main_menu' ) {
                //     // config.storage.setItem('homeApp', null);
                //     value = null;
                // } else {
                //     config.storage.setItem('homeApp', value);
                //     // value = 'last_channel';
                // }

                console.log('save new value ' + value);

                this.variable.value = value;

                callback();
            },
            getter: config.api.getters.userSettings,
            saver:  function ( callback ) {
                window.core.backend.settings.setHomeApp(this.variable.value, callback);
            },
            parent: 'userInterface'
        };
    }

    return {
        id: 'homeApplication',
        icon: 'theme-icon-monitor',
        name: gettext('Home page'),
        description: gettext('Selecting a menu section that will be loaded when you turn on the set-top box'),
        render: config.api.renders.popupSelect,
        data: {
            homeApplication: 'mainMenu'
        },
        requirePortalReboot: true,
        prepareForRender: function ( data, callback ) {
            var preparedData = [
                {name: gettext('Last TV channel'), value: 'last_channel', selected: data.homeApplication === 'lastChannel'},
                {name: gettext('Startup menu'), value: 'main_menu', selected: data.homeApplication  === 'mainMenu'}
            ];

            callback(preparedData);
        },
        prepareForSave: function ( value, callback ) {
            this.data.homeApplication = value;
            callback();
        },
        parent: 'userInterface'
    };

};
